<template>
  <Transition name="fade">
    <Button
      v-if="shouldShowTrigger"
      class="trigger"
      size="medium"
      @click="handleButtonClick"
    >
      Unlock {{ bonus }} off
      <i class="icon icon-cross" @click.stop="hideTrigger" />
    </Button>
  </Transition>
</template>

<script>
import Button from "@/components/Button.vue";
import { signUpBonus } from "@/config";
import { mapGetters, mapActions } from "vuex";
import { getFeatureToggles } from "@/helpers/featureToggles.js";

export default {
  name: "DataCollectionTrigger",
  components: {
    Button,
  },
  computed: {
    ...mapGetters("app", [
      "currencyCode",
      "dataCollectionDismissed",
      "dataCollectionTriggerDismissed",
    ]),
    ...mapGetters("auth", ["isLoggedIn"]),
    shouldShowTrigger() {
      const { showUnlockBonus = false } = getFeatureToggles();

      if (!showUnlockBonus) {
        return false;
      }

      return (
        !this.isLoggedIn &&
        this.bonus &&
        (this.dataCollectionDismissed
          ? !this.dataCollectionTriggerDismissed
          : false)
      );
    },
    bonus() {
      if (!this.currencyCode) {
        return null;
      }
      const amount = signUpBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
  },
  methods: {
    ...mapActions("app", ["setUserPreferences"]),
    handleButtonClick() {
      this.setUserPreferences({
        key: "dataCollectionDismissed",
        value: false,
      });
    },
    hideTrigger() {
      this.setUserPreferences({
        key: "dataCollectionTriggerDismissed",
        value: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.trigger {
  position: fixed;
  bottom: 10px;
  left: 10px;

  @include respond-above(md) {
    bottom: 20px;
    left: 20px;
  }

  ::v-deep(.text) {
    display: flex;
    align-items: center;
  }
}

.icon {
  font-size: 16px;
  margin-left: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
